import { SvgIcon } from "@mui/material";
import React from "react";

export default function LockIcon({ ...props }) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        {...props}
      >
        <path
          d="M3.94141 10.2477C3.94141 9.82959 4.10751 9.42858 4.40317 9.13291C4.69884 8.83725 5.09985 8.67114 5.51798 8.67114H13.4009C13.819 8.67114 14.22 8.83725 14.5157 9.13291C14.8113 9.42858 14.9774 9.82959 14.9774 10.2477V14.9775C14.9774 15.3956 14.8113 15.7966 14.5157 16.0923C14.22 16.3879 13.819 16.554 13.4009 16.554H5.51798C5.09985 16.554 4.69884 16.3879 4.40317 16.0923C4.10751 15.7966 3.94141 15.3956 3.94141 14.9775V10.2477Z"
          stroke="#838383"
          strokeWidth="1.57658"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.3064 8.67118V5.51802C6.3064 4.68175 6.6386 3.87974 7.22993 3.28841C7.82127 2.69707 8.62328 2.36487 9.45955 2.36487C10.2958 2.36487 11.0978 2.69707 11.6892 3.28841C12.2805 3.87974 12.6127 4.68175 12.6127 5.51802V8.67118"
          stroke="#838383"
          strokeWidth="1.57658"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8242 12.6127H11.8321"
          stroke="#838383"
          strokeWidth="1.57658"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.46729 12.6127H9.47517"
          stroke="#838383"
          strokeWidth="1.57658"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.11035 12.6127H7.11823"
          stroke="#838383"
          strokeWidth="1.57658"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
